const { getElements, translateString } = window.BAO.Utils

class WishlistPage extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.populateLists = this.populateLists.bind(this)
    this.refreshListCards = this.refreshListCards.bind(this)
    this.handleWishlistChange = this.handleWishlistChange.bind(this)
    this.setupWishlist = this.setupWishlist.bind(this)

    this.getCurrentWishlistDetails = this.getCurrentWishlistDetails.bind(this)

    this.wishlistError = this.wishlistError.bind(this)

    this.listeners.add(document, 'click', this.handleWishlistChange)

    this.handleBack = this.handleBack.bind(this)
    this.els.back.elements.forEach((backEl) => {
      this.listeners.add(backEl, 'click', () => this.handleBack(true))
    })

    this.handleListsRefresh = this.handleListsRefresh.bind(this)

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.WISHLIST.LISTS_CHANGED,
      this.handleListsRefresh,
    )

    this.handlePopState = this.handlePopState.bind(this)
    window.addEventListener('popstate', this.handlePopState)

    window.SwymCallbacks = window.SwymCallbacks || []
    window.SwymCallbacks.push(() => {
      window._swat.fetchLists({
        callbackFn: (lists) => this.populateLists(lists, true),
        errorFn: this.wishlistError,
      })
    })
  }

  populateLists (lists, readUrlParams) {
    this.refreshListCards(lists)

    if (lists.length > 0) {
      const currentWishlistId =
        this.els['current-wishlist-text'].element.dataset.wishlistId

      if (!currentWishlistId) {
        this.els['current-wishlist-text'].element.setAttribute(
          'data-wishlist-id',
          lists[0].lid,
        )
      }

      this.externalEls['main-heading'].element.setAttribute(
        'aria-hidden',
        false,
      )
      this.externalEls['secondary-heading'].element.setAttribute(
        'aria-hidden',
        true,
      )

      this.els['page-loading'].element.setAttribute('aria-hidden', true)
      this.els['page-home'].element.setAttribute('aria-hidden', false)
      this.els['page-home-header'].element.setAttribute('aria-hidden', true)
      this.els['page-empty'].element.setAttribute('aria-hidden', true)
      this.els['page-wishlist'].element.setAttribute('aria-hidden', true)
    } else {
      this.externalEls['main-heading'].element.setAttribute(
        'aria-hidden',
        false,
      )
      this.externalEls['secondary-heading'].element.setAttribute(
        'aria-hidden',
        true,
      )

      this.els['page-loading'].element.setAttribute('aria-hidden', true)
      this.els['page-home'].element.setAttribute('aria-hidden', true)
      this.els['page-empty'].element.setAttribute('aria-hidden', false)
      this.els['page-wishlist'].element.setAttribute('aria-hidden', true)
    }

    if (readUrlParams) {
      setTimeout(() => {
        this.readUrlParams()
      }, 0)
    }
  }

  refreshListCards (lists) {
    this.els.wishlists.element.innerHTML = this.createAddWishlistElement()

    lists.forEach((list, index) => {
      this.els.wishlists.element.innerHTML += this.createHomeElement(
        list,
        index,
      )
    })
  }

  createAddWishlistElement () {
    return `
      <div class="wsh-Page_Card">
        <button
          type="button"
          class="wsh-Card wsh-Card-create"
          data-drawers-trigger="drawer-wishlist-manage"
          data-wishlist-manage-external-el="trigger"
          data-wishlist-mode="create"
        >
          <span class="wsh-Card_CreateText fz-14_22 fz-14_22-title">
            ${this.translations?.wishlist?.createList}
          </span>
        </button>
      </div>
    `
  }

  createHomeElement (list, index) {
    const latestItem = list.listcontents?.[0]

    const cardImage = latestItem?.iu
      ? `
        <div class="wsh-Card_Media">
          <img class="wsh-Card_Image" src="${latestItem.iu}" alt="${latestItem.dt}">
        </div>
      `
      : ''

    const shareButton =
      this.translations.isCustomer && list.cnt > 0
        ? `
        <button
          type="button"
          class="wsh-Card_Action"
          data-wishlist-share-external-el="trigger"
          data-wishlist-id="${list.lid}"
          data-wishlist-name="${list.lname}"
          aria-label="${translateString(this.translations.wishlist?.shareWishlist ?? '', { wishlist: list.lname })}"
        >
          <span class="wsh-Card_ActionIcon">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18">
              <path fill="currentColor" d="M6.5 6v1H3v10h12V7h-3.5V6H15a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1zm2.551-6a.5.5 0 0 1 .242.087l.073.063 2.116 2.116a.5.5 0 0 1-.707.707L9.499 1.697 9.5 11.5a.5.5 0 0 1-1 0V1.713l-1.26 1.26a.5.5 0 0 1-.706-.707L8.61.187a.5.5 0 0 1 .179-.14L8.855.02l.068-.015L8.964 0z"/>
            </svg>
          </span>
        </button>
      `
        : ''

    return `
      <div class="wsh-Page_Card">
        <div class="wsh-Card util-FauxLink">
          <div class="wsh-Card_MediaContainer">
            <div class="wsh-Card_Controls">
              <button
                type="button"
                class="wsh-Card_Action"
                data-wishlist-delete-external-el="trigger"
                data-wishlist-id="${list.lid}"
                data-wishlist-name="${list.lname}"
                aria-label="${translateString(this.translations.wishlist?.delete.wishlist, { wishlist: list.lname })}"
              >
                <span class="wsh-Card_ActionIcon">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">
                    <path stroke="currentColor" stroke-linejoin="round" stroke-width=".889" d="M3.257 3.605a.444.444 0 0 0-.443.482l.862 10.272c.02.23.212.407.443.407h7.758a.444.444 0 0 0 .442-.407l.862-10.272a.444.444 0 0 0-.442-.482z"/>
                    <path fill="currentColor" d="M14.322 3.258H1.68v.79h12.642z"/>
                    <path stroke="currentColor" stroke-linejoin="round" stroke-width=".889" d="M10.817 1.234h-5.63v2.47h5.63z"/>
                  </svg>
                </span>
              </button>

              ${shareButton}
            </div>

            ${cardImage}
          </div>

          <button
            type="button"
            class="util-FauxLink_Link"
            data-wishlist-page-el="wishlist-change-trigger"
            data-wishlist-id="${list.lid}"
          >
          </button>

          <div class="wsh-Card_Content">
            <p class="wsh-Card_Title fz-18_26 fz-18_26-title">
              ${list.lname} (${list.cnt})
            </p>

            <p class="wsh-Card_Text fz-14_22">${
              list?.anonRead === 1
                ? this.translations.wishlist?.public
                : this.translations.wishlist?.private
            }</p>
          </div>
        </div>
      </div>`
  }

  readUrlParams () {
    const urlParams = new URLSearchParams(window.location.search)
    const wishlistId = urlParams.get('id')

    if (wishlistId) {
      this.setCurrentWishlist(wishlistId, false)
      return
    }

    this.handleBack(false)
  }

  handleWishlistChange (event) {
    const trigger = event.target.closest(
      '[data-wishlist-page-el="wishlist-change-trigger"]',
    )

    if (!trigger) return

    this.setCurrentWishlist(trigger.dataset.wishlistId, true)
  }

  setCurrentWishlist (wishlistId, updateHistory) {
    this.els['current-wishlist-text'].element.setAttribute(
      'data-wishlist-id',
      wishlistId,
    )

    this.getCurrentWishlistDetails(updateHistory)
  }

  getCurrentWishlistDetails (updateHistory) {
    const wishlistId =
      this.els['current-wishlist-text'].element.dataset.wishlistId

    if (!wishlistId) return

    const listConfig = {
      lid: wishlistId,
    }

    window._swat.fetchListDetails(
      listConfig,
      (wishlist) => this.setupWishlist(wishlist, updateHistory),
      this.wishlistError,
    )
  }

  handleListsRefresh () {
    if (!window._swat) return

    const isWishlistOpen =
      this.els['page-wishlist'].element.getAttribute('aria-hidden') === 'false'

    if (isWishlistOpen) {
      this.getCurrentWishlistDetails(false)

      window._swat.fetchLists({
        callbackFn: this.refreshListCards,
        errorFn: this.wishlistError,
      })

      return
    }

    window._swat.fetchLists({
      callbackFn: (lists) => this.populateLists(lists, false),
      errorFn: this.wishlistError,
    })
  }

  async setupWishlist (wishlist, updateHistory) {
    this.els['current-wishlist-text'].element.setAttribute(
      'data-wishlist-id',
      wishlist.list.lid,
    )

    if (this?.els?.share?.exists) {
      const shouldShowShare =
        this.translations.isCustomer && wishlist.list.cnt > 0

      this.els.share.element.setAttribute('aria-hidden', !shouldShowShare)

      if (shouldShowShare) {
        this.els.share.element.setAttribute(
          'data-wishlist-id',
          wishlist.list.lid,
        )
      }
    }

    this.els.delete.element.setAttribute('data-wishlist-id', wishlist.list.lid)
    this.els.delete.element.setAttribute(
      'data-wishlist-name',
      wishlist.list.lname,
    )

    getElements('[data-wishlist-page-el="wishlist-change-trigger"]').forEach(
      (el) => {
        el.setAttribute(
          'aria-current',
          el.dataset.wishlistId === wishlist.list.lid,
        )
      },
    )

    const productCardHTML = await this.getAllProductCardHTML(wishlist)
    this.els.products.element.innerHTML = productCardHTML

    this.externalEls.title.element.textContent = `${wishlist.list.lname} (${wishlist.list.cnt})`

    if (wishlist.list.cnt > 0) {
      this.els['panel-list'].element.setAttribute('aria-hidden', false)
      this.els['panel-empty'].element.setAttribute('aria-hidden', true)
    } else {
      this.els['panel-list'].element.setAttribute('aria-hidden', true)
      this.els['panel-empty'].element.setAttribute('aria-hidden', false)
    }

    this.externalEls['main-heading'].element.setAttribute('aria-hidden', true)
    this.externalEls['secondary-heading'].element.setAttribute(
      'aria-hidden',
      false,
    )

    this.els['page-loading'].element.setAttribute('aria-hidden', true)
    this.els['page-home'].element.setAttribute('aria-hidden', false)
    this.els['page-home-header'].element.setAttribute('aria-hidden', false)
    this.els['page-empty'].element.setAttribute('aria-hidden', true)
    this.els['page-wishlist'].element.setAttribute('aria-hidden', false)

    if (updateHistory) {
      this.updateHistory(wishlist.list.lid, wishlist.list.lname)
    }

    this.updateDocumentTitle(wishlist.list.lname)
  }

  async getAllProductCardHTML (wishlist) {
    const productCardHTML = await Promise.all(
      wishlist.items.map(
        async (product, index) =>
          await this.getProductCardHTML(product, index, wishlist),
      ),
    )

    return productCardHTML.filter(Boolean).join('')
  }

  async getProductCardHTML (product, index, wishlist) {
    const productsIndex = product.du.indexOf('/products/')
    const productUrl = product.du.substr(productsIndex)

    return window.BAO.sectionRenderer
      .fetchSingle(
        'wishlist-product-card',
        `${productUrl}?variant=${product.epi}`,
      )
      .then((res) => {
        const newDOM = window.BAO.sectionRenderer.convertToDOM(res)
        const myself = newDOM.querySelector('article')

        if (myself) {
          const removeEl = myself.querySelector(
            '[data-wishlist-page-el="remove"]',
          )

          if (removeEl) {
            removeEl.setAttribute('data-wishlist-id', wishlist.list.lid)
            removeEl.setAttribute('data-product-id', product.empi)
            removeEl.setAttribute('data-variant-id', product.epi)
            removeEl.setAttribute('data-product-url', product.du)
            removeEl.setAttribute('data-product-title', product.dt)
          }

          const chosenVariantEl = myself.querySelector(
            '[data-wishlist-chosen-variant]',
          )

          const chosenVariantString = product.vi
            ? `${window.theme?.wishlist?.chosenVariant}: ${product.vi}`
            : ''

          if (chosenVariantEl) {
            chosenVariantEl.textContent = chosenVariantString
          }

          return `<div class="prd-List_Item">${myself.outerHTML}</div>`
        }
      })
      .catch(() => {
        return null
      })
  }

  handleBack (updateHistory) {
    if (updateHistory) {
      this.updateHistory()
    }

    this.updateDocumentTitle()

    window._swat.fetchLists({
      callbackFn: (lists) => this.populateLists(lists, false),
      errorFn: this.wishlistError,
    })
  }

  wishlistError (errorMessage) {
    // eslint-disable-next-line
    console.log(`Wishlist error: ${errorMessage}`);

    this.externalEls['main-heading'].element.setAttribute('aria-hidden', false)
    this.externalEls['secondary-heading'].element.setAttribute(
      'aria-hidden',
      true,
    )

    this.els['page-loading'].element.setAttribute('aria-hidden', true)
    this.els['page-home'].element.setAttribute('aria-hidden', true)
    this.els['page-empty'].element.setAttribute('aria-hidden', false)
    this.els['page-wishlist'].element.setAttribute('aria-hidden', true)
  }

  updateHistory (id, title) {
    const url = new URL(window.location.href)

    url.searchParams.delete('id')
    url.hash = ''

    if (id) {
      url.searchParams.set('id', id)
    }

    const search = url.searchParams.toString()
    const nextUrl = `${url.pathname}${search ? `?${search}` : ''}`

    const nextTitle = title
      ? this.dataset.wishlistTitle.replace('#wishlist#', title)
      : this.dataset.defaultTitle

    window.history.pushState({ url: nextUrl, id }, nextTitle, nextUrl)

    document.title = nextTitle
  }

  updateDocumentTitle (title) {
    document.title = title
      ? this.dataset.wishlistTitle.replace('#wishlist#', title)
      : this.dataset.defaultTitle
  }

  handlePopState () {
    this.readUrlParams()
  }

  get translations () {
    return window.theme ?? {}
  }
}

if (!customElements.get('wishlist-page')) {
  customElements.define('wishlist-page', WishlistPage)
}
